import fetch from 'isomorphic-fetch'

export function putRequest(url, data) {
	return fetch(`${ url }`, {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json'
		},
		credentials: 'include'
	})
		.then(response => response.json())
}

export function postRequest(url, data) {
	return fetch(`${ url }`, {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		credentials: 'include'
	})
		.then(response => response.json())
		.catch(e => {
			console.log(e)
		})
}



// WEBPACK FOOTER //
// ./src/client/webapp/helpers/requestActions.js